import { Box, Tooltip, Chip } from '@mui/material';
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import StarsIcon from '@mui/icons-material/Stars';
import PropTypes from 'prop-types';

/**
 * A component that displays prompt version information with an indicator for newer versions
 * Specific to the prompts feature and not intended for general use
 */
const PromptVersionIndicator = ({
	version,
	hasNewerVersion,
	latestVersion,
	isTenantOverride = false,
	isActive = false,
}) => {
	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				width: '100%',
				flexDirection: 'column',
				gap: 0.5,
			}}
		>
			<Box
				sx={{
					position: 'relative',
					display: 'inline-flex',
					alignItems: 'center',
				}}
			>
				{version}

				{hasNewerVersion && (
					<Tooltip title={`Newer version available (v${latestVersion})`}>
						<NewReleasesIcon
							color='warning'
							fontSize='small'
							sx={{ ml: 0.5, verticalAlign: 'middle' }}
						/>
					</Tooltip>
				)}
			</Box>

			{/* Show either the active indicator or tenant default indicator */}
			{isActive ? (
				<Tooltip title="Current Active Version">
					<Chip
						label="Current"
						color="primary"
						size="small"
					/>
				</Tooltip>
			) : isTenantOverride && (
				<Tooltip title='Tenant Override Version'>
					<Chip
						icon={<StarsIcon fontSize='small' />}
						label='Tenant Override'
						color='secondary'
						size='small'
						variant='outlined'
					/>
				</Tooltip>
			)}
		</Box>
	);
};

PromptVersionIndicator.propTypes = {
	version: PropTypes.number.isRequired,
	hasNewerVersion: PropTypes.bool,
	latestVersion: PropTypes.number,
	isTenantOverride: PropTypes.bool,
	isActive: PropTypes.bool,
};

export default PromptVersionIndicator;
